import type { FC } from 'react';
import { useSlate } from 'slate-react';

import { Icon, registerIcon, useI18n } from '@pega/cosmos-react-core';
import type { ForwardProps } from '@pega/cosmos-react-core';
import * as tableIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/table.icon';

import EditorCommands from '../utils/EditorCommands';

import ToolbarButton from './ToolbarButton';

registerIcon(tableIcon);

const TableButton: FC<ForwardProps> = props => {
  const t = useI18n();
  const editor = useSlate();

  const createNewTable = () => {
    EditorCommands.appendTable(editor);
  };

  return (
    <ToolbarButton
      type='button'
      onMouseDown={e => {
        e.preventDefault();
        createNewTable();
      }}
      tooltip={t('rte_table')}
      label={t('rte_table')}
      {...props}
    >
      <Icon name='table' />
    </ToolbarButton>
  );
};

export default TableButton;
